import { createContext } from 'react';

const areaContext = createContext();

export default areaContext;